export const localTranslations = {
  title: 'Статус на зареждане',
  pending: 'Зареждане',
  success: 'Успешно',
  fail: 'Неуспешно',
  checkingUserData: 'Проверка на потребителски данни',
  checkingChannelsData: 'Проверка на данните за канали',
  checkingForErrors: 'Проверка за грешки',
  checkingCategoriesData: 'Проверка на данните за категории',
  checkingVODData: 'Проверка на данните за видеотеката',
  checkingRecordedData: 'Проверка на данните за архив',
  checkingPrismicData: 'Проверка на данните за външни',
  checkingServerTime: 'Проверка на време от сървъра',
  checkingTranslationData: 'Проверка на текстове',
  checkingAuth: 'Проверка на данните за вход',
  playerLoading: 'Зареждане на видео плейър'
};
